import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { validate, validatorFromFunction, validators, combine } from 'validate-redux-form';
import { renderField, renderTextArea, renderCurrency } from '../../../Utils/renderField';
import { Link, Redirect } from 'react-router-dom';


const AnulacionForm = (props) => {
    const { handleSubmit, tiene_monto_credito} = props;
    return (
        <form name="anulacionForm" className="form-validate mb-lg" onSubmit={handleSubmit}>
            <div className="row justify-content-center mt-4">
                <div className="form-group has-feedback col-md-10 col-12">
                    <Field
                        name="descripcionAnulacion"
                        label="descripcionAnulacion"
                        placeholder="Descripción de la anulación"
                        component={renderTextArea}
                        type="text"
                        top ={{top:"67px"}}
                        className="form-control" />
                </div>
                {
                    (tiene_monto_credito) && (
                        <div className="form-group has-feedback col-md-10 col-12">
                            <label>Credito de anulación</label>
                            <Field
                                name="credito"
                                label="credito"
                                component={renderCurrency}
                                prefix={props.simbolo}
                                className="form-control" />
                        </div>
                    )
                }

            </div>

            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <button type="button" onClick={() => {
                            props.cerrarModal(false);
                        }} className="btn btn-secondary  align-self-center">CANCELAR</button>
                        <button type="submit" className="btn btn-primary m-1 align-self-center">GUARDAR</button>
                    </div>
                </div>
            </div>
        </form>
    );
};


export default reduxForm({
    form: 'anulacionForm', // a unique identifier for this form
    validate: (data) => {
        const errors = {};

        if(!data.descripcionAnulacion){
            errors.descripcionAnulacion = 'Este campo es requerido';
        }

        if(data.credito && data.credito < 0 ){
            errors.credito = 'El valor debe ser positivo';
        }
        return errors
    },
})(AnulacionForm);
